import React from 'react';
import VstComponent from './VstComponent';
import classNames from 'classnames';

class VstMenu extends VstComponent {

  constructor() {
    super();
    this._updatePosition = this._updatePosition.bind(this);
    this._clickMenuMask = this._clickMenuMask.bind(this);
    this.state = {
      arrowRight: 15,
      menuRight: 0,
      top: 44
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.visible) {
      this._updatePosition();
    }
  }

  _updatePosition() {
    const callee = this.refs.vstMenu.parentElement.parentElement;
    const menuRight = document.body.offsetWidth - callee.offsetWidth - callee.offsetLeft;
    const offsetRight = ((menuRight < 6) ? (6 - menuRight) : 0);
    this.setState({
      arrowRight: callee.offsetWidth / 2 - 4 - offsetRight,
      menuRight: menuRight + offsetRight,
      arrowTop: callee.offsetTop + callee.offsetHeight + 8
    });
  }

  _clickMenuMask() {
    if (this.props.closeMenu) {
      this.props.closeMenu();
    }
  }

  render() {
    return (
      <span>
        <div style={{ right: this.state.menuRight, top: this.state.arrowTop }}
          ref="vstMenu"
          className={classNames(this.props.className, 'vst-menu', { visible: this.props.visible })}
        >
          <div ref="pointer"
            className="pointer up"
            style={{ right: this.state.arrowRight }}
          />
          {this.props.children}
        </div>
        <div className={classNames('vst-menu-mask', { visible: this.props.visible })} onClick={this._clickMenuMask}></div>
      </span>
    );
  }

}

export default VstMenu;
